import { render } from "./commentaries.vue?vue&type=template&id=c5b74c5c&scoped=true"
import script from "./commentaries.vue?vue&type=script&lang=js"
export * from "./commentaries.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./commentaries.vue?vue&type=style&index=1&id=c5b74c5c&scoped=true&lang=css"

import exportComponent from "D:\\MY PROJECTS\\VUE_3\\EXCEL_LIBRARY\\excel-library-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5b74c5c"]])

export default __exports__